
/**
 * @ngdoc directive
 * @name graduationpanel
 *
 * @description
 * KeyFigures
 */
module.directive('graduationpanel', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            header: '@',
            content: '='
        },
        template: '<div class="aqua-graduationpanel">' +
            '  <h2 class="aqua-graduationpanel--title" ng-if="header">{{ header }}</h2>' +
            '  <table class="aqua-graduationpanel--items">' +
            '   <thead class="aqua-graduationpanel--items-header">' +
            '       <th class="aqua-graduationpanel--items-header--cell l-tac grid-2">{{\'account.graduationDate\'| translate}}</th>' +
            '       <th class="aqua-graduationpanel--items-header--cell l-tal grid-1">{{\'account.graduationType\'| translate}}</th>' +
            '       <th class="aqua-graduationpanel--items-header--cell l-tal grid-8">{{\'account.graduationGoal\'| translate}}</th>' +
            '       <th class="aqua-graduationpanel--items-header--cell l-tac grid-1"><abbr title="{{\'account.graduationAttachmentsLong\'| translate}}">{{\'account.graduationAttachments\'| translate}}</abbr></th>' +
            '   </thead>' +
            
            '   <tbody class="aqua-graduationpanel--items-body" ng-repeat="graduation in content">' +

            '     <tr class="aqua-graduationpanel--item">' +
            '       <td class="aqua-graduationpanel--item-cell l-tac">{{ graduation.obtainingDate | toDate:\'DD/MM/YYYY\' }}</td>' +
            '       <td class="aqua-graduationpanel--item-cell l-tal">[{{ graduation.type }}]</td>' +
            '       <td class="aqua-graduationpanel--item-cell l-tal">{{ graduation.object }}</td>' +
            '       <td rowspan="2" class="aqua-graduationpanel--item-cell aqua-graduationpanel--item-cell--picto l-tac"><span ng-if="graduation.documentUrl"><icon type="document"></icon></span><span ng-if="!graduation.documentUrl"><icon type="document-empty"></icon></span></td>' +
            '     </tr>' +
            '     <tr class="aqua-graduationpanel--item">' +
            '       <td colspan="1"></td>' +
            '       <td colspan="2" class="aqua-graduationpanel--item-cell--info l-tal">{{ graduation.name }}</td>' +
            '     </tr>' +

            '   </tbody>' +

            '   <tbody class="aqua-graduationpanel--items-body" ng-if="content.length === 0">' +
            '     <tr class="aqua-graduationpanel--item">' +
            '       <td class="aqua-graduationpanel--item-cell l-tac" colspan="4">{{ \'account.nograduation\' | translate }}</td>' +
            '     </tr>' +
            '   </tbody>' +
            
            '  </table>' +
            '</div>'
    }
});